import {SmartComponent} from "smart-component-js";


class ProfileComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.init();
    }


    addFormErrorListener() {
        document.addEventListener('yxp-form-config-error-require-logged-user', () => this.showFormError());
        document.addEventListener('yxp-form-config-error-not-authorized', () => this.showFormError());
        document.addEventListener('yxp-form-config-error-date-not-valid', () => this.showFormError());
        document.addEventListener('yxp-form-config-error-already-answered', () => this.showFormError());
        document.addEventListener('yxp-form-config-error', () => this.showFormError());
        document.addEventListener('yxp-form-config-error-not-found', () => this.showFormError());
    }

    showFormError() {
        this.startScreen.remove();
        this.element.querySelector('.yxpType_FORM').classList.add('form-visible');
        this.element.classList.remove('yxpLoading');
    }


    completeProfileMission() {

    }

    addSubmitListener() {
        this.element.classList.remove('loading');
        document.addEventListener('profile-updated', () => {
            this.completeProfileMission();
        });
    }


    forceCapInput() {
        this.capInput = this.element.querySelector('input[name=zipCode]');
        this.capInput.addEventListener('input', () => {
            this.capInput.value = this.capInput.value.replace(/\D/g, '');

            if (this.capInput.value.length > 5) {
                this.capInput.value = this.capInput.value.slice(0, 5);
            }
        });
    }


    init() {
        this.addFormErrorListener();
        document.addEventListener('yxp-form-loaded', () => {
            this.element.querySelector('.yxpType_FORM').classList.add('form-visible');
            this.addSubmitListener();
            this.forceCapInput();

        });
    }
}

export default ProfileComponent;
